import type { ScheduleTab } from '../../domain';
import { scheduleQueryKeys } from '../constants';
import { scheduleOrderRepository } from '../repositories';

function getScheduleOrdersTab() {
  return scheduleOrderRepository.readScheduleOrdersTab();
}

function setScheduleOrdersTab(tab: ScheduleTab) {
  scheduleOrderRepository.updateScheduleOrdersTab(tab);
}

function listScheduledOrders(storeIds: number[]) {
  return scheduleOrderRepository.readScheduledOrders({ store_ids: storeIds });
}

function getScheduledOrderDetail(orderId: number) {
  return scheduleOrderRepository.readScheduledOrderDetail(orderId);
}

function delScheduledOrder(orderId: number) {
  const partnerId = scheduleOrderRepository.readPartnerIdFromProfile();
  return scheduleOrderRepository.updateCancelScheduledOrder({
    orderId,
    partnerId,
  });
}

export const scheduleOrderService = {
  getScheduleOrdersTab,
  setScheduleOrdersTab,
  listScheduledOrders,
  getScheduledOrderDetail,
  delScheduledOrder,
} as const;

export { scheduleQueryKeys };
